// Format Norwegian phone numbers
export function formatPhoneNumber(phone) {
    if (!phone) return '';
    // Remove all non-digit characters
    const digits = phone.replace(/\D/g, '');

    // Format as +47 XX XX XX XX
    if (digits.length === 8) {
        return `+47 ${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(
            4,
            6
        )} ${digits.slice(6, 8)}`;
    } else if (digits.length === 10 && digits.startsWith('47')) {
        return `+47 ${digits.slice(2, 4)} ${digits.slice(4, 6)} ${digits.slice(
            6,
            8
        )} ${digits.slice(8, 10)}`;
    } else {
        return phone; // Return original if it doesn't match expected lengths
    }
}

// Format currency to Norwegian Krone format (e.g., 1234.56 -> "1 234,56 kr")
export function formatCurrency(amount, decimalPlaces = 2, locale = 'no-NO', currency = 'NOK') {
    if (amount == null || isNaN(amount)) return '';
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    }).format(amount);
}
